<template>
  <ul class="formats__list">
    <li v-if="!isFormatAdmin" class="formats__item" v-for="(format,index) in format_list">
      <format-item :index="index" :data-v-long-step="loadStep(index)" :premium="format.premium" :title="format.name" :id="format.id" :description="format.description" :category-id="format.category_id" :preview_icon="format.preview_icon" :preview_image="format.preview_image" :formatdata="format.specification" :series="format.series"></format-item>
    </li>
    <draggable v-if="isFormatAdmin" v-model='format_list'>
      <li class="formats__item" v-for="(format,index) in format_list">
        <format-item :index="index" :data-v-long-step="loadStep(index)" :premium="format.premium" :title="format.name" :id="format.id" :description="format.description" :category-id="format.category_id" :preview_icon="format.preview_icon" :preview_image="format.preview_image" :formatdata="format.specification" :series="format.series"></format-item>
      </li>
    </draggable>
  </ul>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  components: {
    draggable
  },
  name: 'format-listing',
  props: ['formats'],
  methods: {
    loadStep (index) {
      if (index === 0) {
        return 3
      } else {
        return null
      }
    }
  },
  computed: {
    isFormatAdmin () {
      return this.$store.state.me.admin || this.$store.state.me.format_admin
    },
    format_list: {
      get() {
        return this.formats
      },
      set(value) {
        this.$store.commit('formats/updateSort', value);
      }
    },
    sortedFormats: () => {
      return this.formats.sort((a, b) => {
        return a - b;
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/FormatListing.vue